export const VARIAVEIS = ['nome', 'primeiro_nome', 'valor', 'vencimento', 'dias_atraso', 'descricao', 'lista', 'dados_bancarios', 'unidade']

export const recuperacaoInicial = (recuperacao = {}) => ({ ativa: recuperacao?.ativa ?? true, maxDiasAtraso: recuperacao?.maxDiasAtraso ?? 60 })
export const erroDeRecuperacao = recuperacao => Number.isInteger(recuperacao.maxDiasAtraso) && recuperacao.maxDiasAtraso >= 1 && recuperacao.maxDiasAtraso <= 365 ? '' : 'Escolha um limite inteiro de 1 a 365 dias para recuperar cobranças.'

export function configuracaoInicial(config = {}, capacidades = {}) {
  return {
    ddiPadrao: String(config.ddiPadrao ?? capacidades.ddiPadrao ?? '55'),
    moeda: config.moeda || capacidades.moedaPadrao || 'BRL',
    fuso: config.fuso || (String(config.ddiPadrao ?? capacidades.ddiPadrao) === '595' ? 'America/Asuncion' : 'America/Sao_Paulo'),
    tetoDiario: config.tetoDiario ?? 600,
    recuperacao: recuperacaoInicial(config.recuperacao),
    filtroUnidades: config.filtroUnidades || [],
    dadosBancarios: { padrao: '', ...config.dadosBancarios },
    janela: {
      inicio: config.janela?.inicio ?? '08:00', fim: config.janela?.fim ?? '18:00',
      fimSabado: config.janela?.fimSabado ?? '12:00', dias: config.janela?.dias ?? [1, 2, 3, 4, 5, 6]
    }
  }
}

export function validarConfiguracao(config, escolherUnidades) {
  const erros = []
  const { janela } = config
  const erroRecuperacao = erroDeRecuperacao(recuperacaoInicial(config.recuperacao))
  if (erroRecuperacao) erros.push(erroRecuperacao)
  if (!/^[1-9][0-9]{0,2}$/.test(config.ddiPadrao)) erros.push('Informe o código do país com 1 a 3 números, sem zero no início (55 para Brasil ou 595 para Paraguai).')
  const horaValida = valor => /^([01]\d|2[0-3]):[0-5]\d$/.test(valor)
  if (!horaValida(janela.inicio) || !horaValida(janela.fim) || janela.inicio >= janela.fim) erros.push('O início precisa ser antes do fim dos envios.')
  if (janela.dias.includes(6) && (!horaValida(janela.fimSabado) || janela.inicio >= janela.fimSabado)) erros.push('No sábado, o fim precisa ser depois do início dos envios.')
  if (!janela.dias.length) erros.push('Escolha pelo menos um dia de envio.')
  if (!Number.isSafeInteger(config.tetoDiario) || config.tetoDiario < 1) erros.push('Informe um limite diário inteiro maior que zero.')
  if (escolherUnidades && !config.filtroUnidades.length) erros.push('Escolha pelo menos uma unidade ou marque todas.')
  return erros
}

export const CATALOGO_ROTINAS = [
  { chave: 'gerada', titulo: 'Avisar quando a cobrança for gerada', intervalo: true },
  { chave: 'antes', titulo: 'Lembrar antes do vencimento', permiteDias: true },
  { chave: 'vence_hoje', titulo: 'Lembrar no dia do vencimento' },
  { chave: 'atraso_1', titulo: 'Cobrar depois do vencimento', permiteDias: true, requer: 'baixa' },
  { chave: 'atraso_2', titulo: 'Cobrar de novo depois do vencimento', permiteDias: true, requer: 'baixa' },
  { chave: 'pago', titulo: 'Agradecer o pagamento', intervalo: true, requer: 'baixa' }
]

export function validarTexto(texto, disponiveis = VARIAVEIS) {
  const erros = []
  if (!texto.trim()) erros.push('Escreva a mensagem antes de salvar.')
  if (texto.length > 4096) erros.push('Use até 4.096 caracteres por mensagem.')
  const restante = texto.replace(/\{([^{}]+)\}/g, (marca, chave) => {
    if (!disponiveis.includes(chave)) erros.push(`A variável ${marca} não está disponível.`)
    return ''
  })
  if (/[{}]/.test(restante)) erros.push('Use uma chave para abrir e outra para fechar a variável, como {nome}.')
  return [...new Set(erros)]
}

export function renderizarTexto(texto, contexto = {}) {
  return texto.replace(/\{([^{}]+)\}/g, (_, chave) => String(contexto[chave] ?? '').trim() || `[${chave} sem valor]`)
}

export function mensagemDeErro(erro) {
  const status = erro?.response?.status
  const dados = erro?.response?.data || {}
  if (erro?.code === 'ECONNABORTED' || status === 504) return 'A consulta ao sistema de gestão demorou demais. Tente de novo em instantes.'
  if (erro?.request && !erro.response) return 'Não foi possível falar com o servidor. Confira sua internet e tente de novo.'
  if (!erro?.response && typeof erro?.message === 'string' && erro.message.trim()) return erro.message
  if (status === 500 && typeof dados.message === 'string' && dados.message.trim()) return dados.message
  if (status === 403) return 'HiperSync não está habilitado no seu plano.'
  if (status === 429) return dados.message || 'Aguarde um pouco antes de tentar novamente.'
  if (dados.codigo === 'LIMITE_ERP') return 'Aguarde um pouco antes de tentar novamente.'
  if (dados.codigo === 'CREDENCIAL_ERP') return 'Confira o usuário e a senha do sistema de gestão.'
  if (status === 502) return 'O sistema de gestão está indisponível agora. Tente novamente em alguns minutos.'
  if (status === 422) return Object.values(dados.campos || {}).filter(v => typeof v === 'string').join(' ') || dados.message || 'Confira os campos antes de salvar.'
  if (status === 404) return 'Salve a conexão antes de continuar.'
  if (status === 401) return 'Confira o usuário e a senha do sistema e tente novamente.'
  return 'Não foi possível concluir. Confira os dados e tente novamente.'
}

export function dataNoFuso(fuso = 'America/Sao_Paulo', agora = new Date()) {
  const partes = new Intl.DateTimeFormat('en-CA', { timeZone: fuso, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(agora)
  const obter = chave => partes.find(p => p.type === chave).value
  return `${obter('year')}-${obter('month')}-${obter('day')}`
}

export function somarDias(data, quantidade) {
  const dia = new Date(`${data}T12:00:00Z`)
  dia.setUTCDate(dia.getUTCDate() + quantidade)
  return dia.toISOString().slice(0, 10)
}

export function validarPeriodo(de, ate) {
  const inicio = Date.parse(`${de}T00:00:00Z`)
  const fim = Date.parse(`${ate}T00:00:00Z`)
  if (!Number.isFinite(inicio) || !Number.isFinite(fim) || fim < inicio) return 'Escolha um período válido, com o início antes do fim.'
  return (fim - inicio) / 86400000 >= 31 ? 'Escolha um período de até 31 dias.' : ''
}

export const nomeDaRotina = chave => CATALOGO_ROTINAS.find(r => r.chave === chave)?.titulo || 'Outra rotina'
export const dataLegivel = data => /^\d{4}-\d{2}-\d{2}$/.test(data || '') ? data.split('-').reverse().join('/') : '—'
export const MOTIVOS = {
  MODELO_OFICIAL: 'Conexão da API Oficial: use um modelo aprovado', SEM_CONEXAO: 'Número desconectado — reconecte pelo QR',
  SITUACAO: 'Não está em aberto', FORA_DO_EXPEDIENTE_DA_CONEXAO: 'Fora do expediente do número',
  OUTRA_ROTINA_NO_DIA: 'Já recebe outra mensagem hoje',
  AGUARDANDO_PRIMEIRA_COBRANCA: 'Aguardando a 1ª cobrança sair',
  CANCELADA_COM_GRUPO: 'Cancelada junto com o grupo pago', ROTINA_DESLIGADA: 'Rotina desligada', PILOTO_PAUSADO: 'Piloto pausado',
  TETO_DA_INTEGRACAO: 'Limite diário definido para o Piloto',
  DADOS_INCOMPLETOS_ERP: 'Dados incompletos no sistema', VARIAVEL_SEM_VALOR: 'Faltou uma informação na mensagem',
  FORA_DO_EXPEDIENTE: 'Fora do horário de envio', NAO_ENCONTRADA_NO_ERP: 'Cobrança não encontrada no sistema',
  TELEFONE_INVALIDO: 'Telefone inválido', SEM_TELEFONE: 'Sem telefone', OPT_OUT: 'Cliente pediu para sair',
  BLOQUEIO_MANUAL: 'Envio bloqueado', LIMITE_DIARIO: 'Limite diário do número', JA_ENVIADA: 'Já recebeu esta rotina', ANTES_DE_LIGAR: 'Anterior à ativação'
}
export const textoDoMotivo = (motivo, rotina) => motivo === 'SITUACAO' && rotina === 'pago' ? 'Pagamento ainda não registrado' : MOTIVOS[motivo] || (
  typeof motivo === 'string' && motivo.trim() && !/^[a-z0-9_.-]+$/i.test(motivo.trim()) ? motivo : 'Outro motivo'
)
export const SITUACOES = {
  enfileirado: 'Na fila', enviado: 'Enviada', entregue: 'Entregue', lido: 'Lida', falhou: 'Falhou', nao_enviado: 'Não enviada',
  cancelado: 'Cancelada', retido_smartfilter: 'Retida pelo filtro', aguardando_aprovacao: 'Aguardando aprovação', suprimido: 'Envio impedido'
}

// Exemplo de composição, sem cobrança ou telefone de cliente.
export function contextoDeExemplo(config = {}) {
  return {
    nome: 'Marina Souza', primeiro_nome: 'Marina', valor: config.moeda === 'PYG' ? 'Gs. 80.000' : 'R$ 80,00',
    vencimento: '28/10/2026', dias_atraso: '2', descricao: 'Mensalidade de exemplo',
    lista: 'Mensalidade de exemplo · 28/10/2026', unidade: 'Unidade de exemplo',
    // Na prévia vale a conta padrão; sem ela, a primeira conta de regional preenchida.
    dados_bancarios: String(config.dadosBancarios?.padrao || '').trim() || Object.values(config.dadosBancarios || {}).map(v => String(v || '').trim()).find(Boolean) || 'Banco de exemplo · Conta 00000'
  }
}
